import { Controller } from '@hotwired/stimulus'
import { ScrollScene } from 'scrollscene'
import Typewriter from 'typewriter-effect/dist/core'

export default class extends Controller {
    static targets = ['typewriter'];

    typewriterTargetConnected(element) {
        new ScrollScene({
            triggerElement: element
        }).Scene.on('enter', () => {
            element.style.minHeight = element.offsetHeight + 'px';

            const html = element.innerHTML;

            element.classList.add('typewriter-reveal');
            
            const typewriter = new Typewriter(element, {
                loop: false,
                delay: 1,
                cursor: ''
            });
            
            typewriter.typeString(html).start();
        });
    }
}
